module.exports = __webpack_public_path__ + "media/images/regional-image22-aeb0f7cd9e9a8daa4260294c8a4b7291.jpg";